import type { Cache } from '@urql/exchange-graphcache';
import { DateTime } from 'luxon';
import { graphql } from '@/gql/graphql';
import useAuthStore from '@/stores/useAuthStore';
import appendFields from '@/utils/appendFields';
import buildOptimisticMessageMentions, {
  OptimisticMessageMentionPersonFragment,
} from './buildOptimisticMessageMentions';

const InsertMessageOneOptimisticFragment = graphql(/* GraphQL */ `
  fragment InsertMessageOneOptimistic on person {
    __typename
    id
    avatar_id
    name
    color
  }
`);

export default function insert_message_one(
  args: {
    object: ReturnType<typeof graphql.scalar<'message_insert_input'>> & {
      chat_id: string;
      id: string;
    };
  },
  cache: Cache,
) {
  const datetime = DateTime.utc().toISO();
  const userId = useAuthStore.getState().uid;

  const creator = cache.readFragment(InsertMessageOneOptimisticFragment, {
    __typename: 'person',
    id: userId,
  });

  const media = appendFields(args.object.media?.data || [], {
    __typename: 'message_media',
    created_by: userId,
    message_id: args.object.id,
  });

  const mentions = buildOptimisticMessageMentions(
    args.object.mentions?.data ?? [],
    (personId) =>
      cache.readFragment(OptimisticMessageMentionPersonFragment, {
        __typename: 'person',
        id: personId,
      }),
  );

  // TODO Fix types
  const result = {
    __typename: 'message',
    id: args.object.id,
    content: args.object.content ?? null,
    content_template: args.object.content_template ?? null,
    deleted_at: null,
    created_at: datetime,
    edited_at: null,
    chat_id: args.object.chat_id,
    chat: {
      __typename: 'chat',
      id: args.object.chat_id,
      last_message_at: datetime,
    },
    creator: {
      __typename: 'person',
      id: creator?.id,
      avatar_id: creator?.avatar_id,
      name: creator?.name,
      color: creator?.color,
    },
    media,
    mentions,
    reaction_count: [],
    your_reactions: [],
  };

  return result;
}
